
import React, { useState, useRef, useLayoutEffect, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Thumbs } from 'swiper/modules';
import { useTranslation } from 'react-i18next';
import * as httpService from '../services/HTTPService';
import { ToastContainer, toast } from 'react-toastify';
import SwiperCore, {
  } from 'swiper';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import { useNavigate } from 'react-router-dom';

SwiperCore.use([Navigation,Thumbs]);
export default (props: any) => {
    const publicUrl = process.env.PUBLIC_URL;
    const defaultImageUrl = publicUrl + '/img/no-photo.png';
    const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore>();
    const swiper1Ref = useRef<any>(null);
    const swiper2Ref = useRef(null);
    const navigate = useNavigate();
    const [isMobVer, setIsMobVer] = useState(false);
    const [sliderItems, setSliderItems] = useState([]);
    
    const { t, i18n } = useTranslation();

   const replaceImage = (error:any) => {
      //replacement of broken Image
      error.target.src = defaultImageUrl;
  }

  const onItemClick = (item:any) => {
    props.loadCurrentMoodboard(item);
  }

  const removeBoard = (item: any) => {
    httpService.removeMoodboardById(item.id).then((res) => {
      if(res) {
        toast.success(t('pages.removalSuccessful'));
        if(props.getAllMoodboards) {
          props.getAllMoodboards();
        }
      }
    })
    .catch((err) => {
      if(err) {
        toast.error(t('forms.commonErrMsg'));
      }
    })
    
  }

  useLayoutEffect(() => {
    if (swiper1Ref.current !== null) {
      swiper1Ref.current.controller.control = swiper2Ref.current;
    }
  }, []);

  useEffect(() => {
          const isMobile = document.querySelector('.mobile-app') ? true : false;
          const imgUrl = defaultImageUrl;
          setIsMobVer(isMobile);
          let slItems: any = [...props.sliderSource];
          setSliderItems(slItems);
      }, []
  )

  if(sliderItems && sliderItems.length > 0) {
    return (
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Thumbs]}
          spaceBetween={50}
          slidesPerView={isMobVer ? 1: 3}
          navigation
          thumbs={{
            swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
          }}
          onSlideChange={() => console.log('slide change')}
          onSwiper={(swiper: any) => {
            if (swiper1Ref.current !== null) {
              swiper1Ref.current = swiper;
            }
          }}
        >
          {sliderItems.map((element: any, index: any) => {
            return (
             <SwiperSlide >
              {element.products && element.products.length > 0 ? (
                <>
                  <span className="inter-bold remove" onClick={() => removeBoard(element)}>{t('pages.remove')}</span>
                  {/* <div className='swiper-over'></div> */}
                  <ul className="flex-box" key={index}>
                  {element.products.length === 1 ? (
                        <>
                        {[1].map((p: any, i: any) => {
                          return(
                            <>
                            <li key={i} onClick={() => onItemClick(element)}>
                                <img 
                                  onError={replaceImage}
                                  src={element.products[0].imageUrl} 
                                  alt="product picture" 
                                />
                            </li>
                            <li key={i} onClick={() => onItemClick(element)}>
                                <img 
                                  onError={replaceImage}
                                  src={defaultImageUrl} 
                                  alt="product picture" 
                                />
                            </li>
                            <li key={i} onClick={() => onItemClick(element)}>
                                <img 
                                  onError={replaceImage}
                                  src={defaultImageUrl} 
                                  alt="product picture" 
                                />
                            </li>
                            </>
                          )
                        })}
                        </>
                      ) : null}

                      {element.products.length === 2 ? (
                        <>
                        {[1].map((p: any, i: any) => {
                          return(
                            <>
                            <li key={i} onClick={() => onItemClick(element)}>
                                <img 
                                  onError={replaceImage}
                                  src={element.products[0].imageUrl} 
                                  alt="product picture" 
                                />
                            </li>
                            <li key={i} onClick={() => onItemClick(element)}>
                                <img 
                                  onError={replaceImage}
                                  src={element.products[1].imageUrl} 
                                  alt="product picture" 
                                />
                            </li>
                            <li key={i} onClick={() => onItemClick(element)}>
                                <img 
                                  onError={replaceImage}
                                  src={defaultImageUrl} 
                                  alt="product picture" 
                                />
                            </li>
                            </>
                          )
                        })}
                        </>
                      ) : null}

                      {element.products.length > 2 ? (
                          <>
                            {element.products.map((p: any, i: any) => {
                            if(i < 3) {
                              return (
                                <li key={i} onClick={() => onItemClick(element)}>
                                    <img 
                                      onError={replaceImage}
                                      src={p.imageUrl} 
                                      alt="product picture" 
                                    />
                                </li>
                              )
                            }
                            return null
                          })}
                        </>
                      ) : null}
                      
                  </ul>
                </>
              ) : (
                <>
                  <span className="inter-bold remove" onClick={() => removeBoard(element)}>{t('pages.remove')}</span>
                  <ul className="flex-box" key={index}>
                      {[1,2,3].map((p: any, i: any) => {
                        if(i < 3) {
                          return (
                            <li key={i} onClick={() => onItemClick(element)}>
                                <img 
                                  onError={replaceImage}
                                  src={defaultImageUrl} 
                                  alt="product picture" 
                                />
                            </li>
                          )
                        }
                        return null
                      })}
                  </ul>
                </>
              ) }
                
                <h4 className="inter-light">{element.name ? element.name : ""}</h4>
                <div>
                  {element.products && element.products.length > 0 ? (
                    <span>{element.products.length} {element.products.length === 1 ? ` ${t('pages.element')}`  : ` ${t('pages.elements')}`}</span>
                  ) : (
                    <span>0  {t('pages.elements')}</span>
                  )}
                </div>
              </SwiperSlide>
            )
          })}

        </Swiper>   
    )
  }
  else {
    return (
      <Swiper
      modules={[Navigation, Pagination, Scrollbar, A11y, Thumbs]}
        spaceBetween={50}
        slidesPerView={1}
        navigation
        thumbs={{
          swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
        }}
        onSlideChange={() => console.log('slide change')}
        onSwiper={(swiper: any) => {
          if (swiper1Ref.current !== null) {
            swiper1Ref.current = swiper;
          }
        }}
      >
        <SwiperSlide>
          <img src={`${publicUrl}/img/grid/Rectangle10.png`} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={`${publicUrl}/img/grid/Rectangle11.png`} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={`${publicUrl}/img/grid/Rectangle10.png`} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={`${publicUrl}/img/grid/Rectangle11.png`} />
        </SwiperSlide>
        <SwiperSlide>Slide 4</SwiperSlide>
  
      </Swiper>
    );
  }
  
};